<!-- Sidebar Header starts -->
<div class="sidebar-header" *ngIf="config?.layout.menuPosition === 'Side'">
    <div class="logo clearfix">
      <a [routerLink]="['Dashboard']" class="logo-text float-left">
        <div *ngIf="!logoFlag" class="logo-img">
          <img [src]="logoUrl" alt="NetVidyalaya" />
        </div>
        <span class="text align-middle"></span>
      </a>
      <a class="nav-toggle d-none d-lg-none d-xl-block" id="sidebarToggle" href="javascript:;" (click)="toggleSidebar()">
        <em #toggleIcon [ngClass]="{
          'ft-toggle-left': config.layout.sidebar.collapsed,
          'ft-toggle-right': !config.layout.sidebar.collapsed
        }" class="toggle-icon"></em>
      </a>
      <a class="nav-close d-block d-lg-block d-xl-none" id="sidebarClose" href="javascript:;" (click)="CloseSidebar()">
        <em class="ft-x"></em>
      </a>
    </div>
  </div>
  <!-- Sidebar Header Ends -->
  
  <!-- Sidebar Content starts -->
  <div class="sidebar-content main-menu-content" [perfectScrollbar] [disabled]="!perfectScrollbarEnable">
    <div class="nav-container">
      <ul class="navigation" appSidebarDropdown auto>
        <li appSidebarlink *ngFor="let menuItem of DashboardInformationDto?.menus" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}">
          <a *ngIf="!menuItem.isExternalLink" routerLink="/{{menuItem.pageURL.replace(' ','') }}">
            <em *ngIf="menuItem.icon; else homeIcon" [ngClass]="[menuItem.icon]"></em>&nbsp;
            <ng-template #homeIcon>
              <em [ngClass]="'ft-home'"></em>&nbsp;
            </ng-template>
            <span class="menu-title">{{ menuItem.menuTitle | translate }}</span>
          </a>
          <a [href]="[menuItem.pageURL.replace(' ','')]" target="_blank" *ngIf="menuItem.isExternalLink">
            <em [ngClass]="[menuItem.icon]"></em>
            <span class="menu-title">{{ menuItem.menuTitle | translate }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>